import "./DedActivityList.css";

/* --------- Pagination --------- */
const DetPagination = ({
  page,
  pages,
  onChange,
}: {
  page: number;
  pages: number;
  onChange: (p: number) => void;
}) => {
  const range: number[] = [];
  const start = Math.max(1, page - 3);
  const end = Math.min(pages, start + 6);
  for (let p = start; p <= end; p++) range.push(p);

  return (
    <div className="ded-activity-pagination">
      <button
        className="ded-activity-page-btn"
        onClick={() => onChange(page - 1)}
        disabled={page === 1}
        aria-label="Previous"
      >
        ‹
      </button>
      {range.map((p) => (
        <button
          key={p}
          className={`ded-activity-page-btn ${p === page ? "active" : ""}`}
          onClick={() => onChange(p)}
        >
          {p}
        </button>
      ))}
      <button
        className="ded-activity-page-btn"
        onClick={() => onChange(page + 1)}
        disabled={page === pages}
        aria-label="Next"
      >
        ›
      </button>
    </div>
  );
};
export default DetPagination;
